// extracted by mini-css-extract-plugin
module.exports = {"questionNumber":"QuestionNumber_questionNumber__2VTnr"};